// extracted by mini-css-extract-plugin
export default {"header":"HkJ2CS","headerRightSide":"PUNMEf","pinnedIcon":"zwtK4L","moreButton":"P27AFL","indicatorWrapper":"orzbkD"};